import Fingerprint2 from 'fingerprintjs2'

'use strict';

document.fingervals = undefined;

(function (axios) {
    if (window.requestIdleCallback) {
        requestIdleCallback(function () {
            fingerprint();
        })
    } else {
        setTimeout(function () {
            fingerprint();
        }, 500);
    }

    function fingerprint() {
        Fingerprint2.get({
            excludes: {
                webdriver: true,
                deviceMemory: true,
                hardwareConcurrency: true,
                userAgent: true,
                sessionStorage: true,
                localStorage: true,
                indexedDb: true,
                addBehavior: true,
                openDatabase: true,
                doNotTrack: true,
                plugins: true,
                canvas: true,
                webgl: true,
                adBlock: true,
                fonts: true,
                audio: true,
                enumerateDevices: true,
            }
        }, function (components) {
            // console.log(components);
            let values = components.map(function (component) {
                return component.value
            })
            let murmur = Fingerprint2.x64hash128(values.join(''), 31);

            const slug = document.location.href.split('#')[0].split('/').slice(4).join('/');

            sendSetViewRequest(slug, murmur);

            document.fingervals = values;
        });
    }

    async function sendSetViewRequest(slug, hash) {
        await axios.post(`/articles/${slug}/set-view`, {hash}, {
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        });
    }

    async function sendSetLikeRequest(slug, hash) {
        await axios.post(`/articles/${slug}/set-like`, {hash}, {
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        });
    }

    async function sendUnsetLikeRequest(slug, hash) {
        await axios.post(`/articles/${slug}/unset-like`, {hash}, {
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
        });
    }

    function storeLike(slug) {
        const millis = Date.now();

        document.cookie = `cbo-like=${millis}; path=/articles/${slug}`;
    }

    function removeLike(slug) {
        const millis = Date.now();

        document.cookie = `cbo-like=${millis}; path=/articles/${slug}; max-age=-1`;
    }

    $(function () {
        const slug = document.location.href.split('#')[0].split('/').slice(4).join('/');

        const likesCount = Number($('.js-like-counter').text());
        let isLiked = getCookie('cbo-like');

        // если локальная метка лайка присутствует, вклоючить переключатель
        if (isLiked != null) {
            $('.js-like').attr('checked', true);

            console.log(Date.now() - (5 * 60 * 1000), Number(isLiked), Date.now() - (5 * 60 * 1000) - Number(isLiked));

            // если время метки ещё не истекло, лайк ещё можно отменить
            if (Date.now() - (5 * 60 * 1000) < Number(isLiked)) {
                $('.js-like-counter').text(likesCount + 1);
            } else {
                $('.js-like').attr('disabled', true);
            }

            isLiked = true;
        }

        $('.js-like').change(async function () {
            if (document.fingervals) {
                let murmur = Fingerprint2.x64hash128(document.fingervals.join(''), 31);

                $('.js-like').attr('disabled', true);

                if (!isLiked) {
                    $('.js-like-counter').text(likesCount + 1)
                    await sendSetLikeRequest(slug, murmur);
                    storeLike(slug);
                    isLiked = true;

                } else {
                    $('.js-like-counter').text(likesCount)
                    await sendUnsetLikeRequest(slug, murmur);
                    removeLike(slug);
                    isLiked = false
                }

                $('.js-like').attr('disabled', false);
            }
        })
    })
})(window.axios);

// возвращает куки с указанным name,
// или undefined, если ничего не найдено
function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    console.log(matches);

    return matches ? decodeURIComponent(matches[1]) : undefined;
}